import { InjectionToken } from '@angular/core';

export const WHITELIST_COOKIE = new InjectionToken<string>('WhitelistCookie');
